import useQueryBuilderConfig from './queryBuilderConfigHook.js'

export { useQueryBuilderConfig }
